import TruCard from '../../TruCard';
import { useNavigate } from "react-router";
import ResourceItem from '../items/ResourceItem';

export default function InboxUnreadsList({ practitionerList, unreads }) {
  const navigate = useNavigate();

  const unreadCounts = unreads.reduce((acc, { authorId, threadId }) => {
    if (!acc[authorId]) {
      acc[authorId] = new Set();
    }
    acc[authorId].add(threadId);
    return acc;
  }, {});

  const practitionersWithUnreads = practitionerList.filter(prac => unreadCounts[prac.id] && unreadCounts[prac.id].size > 0);

  return (
    <TruCard title={'Inbox'}>
      {practitionersWithUnreads.length === 0 &&(
        <div style={{ display: 'flex', justifyContent: 'center' }}>No Unread Messages</div>
      )}
      {practitionersWithUnreads.map(prac => {
        const count = unreadCounts[prac.id].size;
        return (
          <ResourceItem
            icon="mail"
            label={`${prac.firstName} ${prac.lastName}`}
            secondary={`${count} Unread${count > 1 ? 's' : ''}`}
            actionLink={() => navigate(`/practitioners/${prac.id}/inbox`)}
          />
        );
      })}
    </TruCard>
  );
}